import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {Store} from "@ngxs/store";
import {Observable} from "rxjs";
import {GetAccountStatusAction} from "../actions/account.actions";
import {GetChequeParametersAction} from "../actions/cheque.actions";

@Injectable({ providedIn: 'root' })
export class ChequeParameterResolver  {
  constructor(private store: Store) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.store.dispatch(new GetChequeParametersAction())
  }
}
